/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostMynaJobsRequestBodyTypename = "PostMynaJobsRequestBody" as const;

/**
 *
 * @export
 * @interface PostMynaJobsRequestBody
 */
export interface PostMynaJobsRequestBody {
  /**
   * given auth code from myna portal
   * @type {string}
   * @memberof PostMynaJobsRequestBody
   */
  authCode: string;
  /**
   *
   * @type {Date}
   * @memberof PostMynaJobsRequestBody
   */
  from: string;
  /**
   *
   * @type {Date}
   * @memberof PostMynaJobsRequestBody
   */
  to: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostMynaJobsRequestBody
   */
  readonly __typename?: string;
}

export function PostMynaJobsRequestBodyFromJSON(json: any): PostMynaJobsRequestBody {
  return PostMynaJobsRequestBodyFromJSONTyped(json, false);
}

export function PostMynaJobsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostMynaJobsRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostMynaJobsRequestBodyTypename,

    authCode: json["auth_code"],
    from: json["from"],
    to: json["to"],
  };
}

export function PostMynaJobsRequestBodyToJSON(object?: PostMynaJobsRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    auth_code: value.authCode,
    from: tzDate(value.from).format(),
    to: tzDate(value.to).format(),
  };
}
